import React, { useState } from 'react';
import { Plus, LogOut, X } from 'lucide-react';

const Sidebar = ({
  userName,
  userEmail,
  sessionsList,
  currentSessionId,
  currentSessionName,
  onNewChat,
  onLoadSession,
  onLogout,
  onClose
}) => {
  const [selectedSessionId, setSelectedSessionId] = useState(currentSessionId);
  const [isLoadingSession, setIsLoadingSession] = useState(false);

  // ✨ NEW: Auto-load session when selected from dropdown
  const handleSessionChange = async (e) => {
    const newSessionId = e.target.value;
    setSelectedSessionId(newSessionId);

    // Don't reload if it's already the current session
    if (newSessionId === currentSessionId) {
      return;
    }

    // Auto-load the selected session
    setIsLoadingSession(true);
    try {
      await onLoadSession(newSessionId);
    } finally {
      setIsLoadingSession(false);
    }
  };

  return (
    <div className="sidebar">
      {/* Close Button */}
      <button 
        onClick={onClose}
        className="sidebar-close-btn"
        aria-label="Close sidebar"
      >
        <X size={20} />
      </button>

      {/* User Info Section */}
      <div className="sidebar-section">
        <h3 className="sidebar-heading">👤 Current User</h3>
        <div className="user-info">
          <p className="user-name"><strong>Name:</strong> {userName}</p>
          <p className="user-email"><strong>Email:</strong> {userEmail}</p>
        </div>
      </div>

      <div className="sidebar-divider" />

      {/* Sessions Section */}
      <div className="sidebar-section">
        <h3 className="sidebar-heading">📚 Your Sessions</h3>

        {/* New Chat Button */}
        <button
          onClick={onNewChat}
          className="btn btn-secondary btn-full sidebar-btn"
        >
          <Plus size={18} />
          New Chat
        </button>

        {/* Sessions List */}
        {sessionsList && sessionsList.length > 0 && (
          <div className="sessions-list">
            <label className="sessions-label">Sessions</label>
            <select
              value={selectedSessionId || ''}
              onChange={handleSessionChange}  // ← Changed: Auto-loads now
              disabled={isLoadingSession}      // ← New: Disable while loading
              className="sessions-select"
            >
              {sessionsList.map((session) => (
                <option key={session.session_id} value={session.session_id}>
                  {session.session_name}
                </option>
              ))}
            </select>

            {/* Show loading indicator below dropdown if loading */}
            {isLoadingSession && (
              <div style={{ 
                fontSize: '0.875rem', 
                color: '#6B7280', 
                marginTop: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <div className="spinner-small" />
                Loading session...
              </div>
            )}

            {/* REMOVED: Load Session Button - No longer needed! */}
          </div>
        )}

        {/* REMOVED: Current Session Indicator - No longer needed! */}
      </div>

      <div className="sidebar-divider" />

      {/* Logout Button */}
      <div className="sidebar-section">
        <button
          onClick={onLogout}
          className="btn btn-outline btn-full sidebar-btn"
        >
          <LogOut size={18} />
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
